import { JSX } from 'react'
import ArrowDownIcon from 'assets/svgr-icons/Arrow_Down.svg'
import * as Styled from './styled'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { useResponsive } from 'hooks/useResponsive'

interface IProps {
  toggleDropdown: () => void
  content: JSX.Element
  isOpen: boolean
  className?: string
  hasTogglerArrow?: boolean
  disabled?: boolean
}

export const DropdownButton: React.FC<IProps> = props => {
  const {
    toggleDropdown,
    content,
    isOpen,
    className,
    hasTogglerArrow,
    disabled = false
  } = props
  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  return (
    <Styled.DropdownButtonWrapper
      onClick={disabled ? undefined : toggleDropdown}
      $isOpen={isOpen}
      $disabled={disabled}
      className={className}
    >
      <Styled.ContentWrapper>{content}</Styled.ContentWrapper>
      {!isTablet && hasTogglerArrow && (
        <Styled.ArrowWrapper $isOpen={isOpen}>
          <ArrowDownIcon />
        </Styled.ArrowWrapper>
      )}
    </Styled.DropdownButtonWrapper>
  )
}

export default DropdownButton
